import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./homeTest/homeTest.module').then((m) => m.HomeTestModule),
      },
      {
        path: 'homeTest',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'home-gruppi',
        loadChildren: () =>
          import('./home-gruppi/home-gruppi.module').then((m) => m.HomeGruppiModule),
      },
      {
        path: 'home-famiglie',
        loadChildren: () =>
          import('./home-famiglie/home-famiglie.module').then((m) => m.HomeFamiglieModule),
      },
      {
        path: 'prodotti/:categoria/:idProdotto/:nomeProdotto',
        loadChildren: () =>
          import('./scheda-prodotto/scheda-prodotto.module').then((m) => m.SchedaProdottoModule),
      },
      
      {
        path: 'elencoProdotti',
        loadChildren: () =>
          import('./elenco-prodotti/elenco-prodotti.module').then((m) => m.ElencoProdottiModule),
      },
      {
        path: 'elencoProdotti/:paramSearch',
        loadChildren: () =>
          import('./elenco-prodotti/elenco-prodotti.module').then((m) => m.ElencoProdottiModule),
      },

      {
        path: 'elencoProdottiCat/:paramCat/:livelloCat',
        loadChildren: () =>
          import('./elenco-prodotti/elenco-prodotti.module').then((m) => m.ElencoProdottiModule),
      },

      {
        path: 'registrati',
        loadChildren: () =>
          import('./auth/registrati/registrati.module').then((m) => m.RegistratiModule),
      },

      {
        path: 'accedi',
        loadChildren: () =>
          import('./auth/login/login.module').then((m) => m.LoginModule),
      },

      {
      path: 'recupera-password',
      loadChildren: () =>
        import('./auth/recupera-password/recupera-password.module').then((m) => m.RecuperaPasswordModule),
    },

      {
        path: 'volantino',
        loadChildren: () =>
          import('./volantino/volantino.module').then((m) => m.VolantinoModule),
      },

      {
        path: 'cart',
        loadChildren: () =>
          import('./cart/cart.module').then((m) => m.CartModule),
      },

      {
        path: 'volantino-dettaglio/:idvolantino',
        loadChildren: () =>
          import('./volantino-dettaglio/volantino-dettaglio.module').then((m) => m.VolantinoDettaglioModule),
      },

      {
        path: 'volantino-dettaglio/:idvolantino/:paramSearch',
        loadChildren: () =>
          import('./volantino-dettaglio/volantino-dettaglio.module').then((m) => m.VolantinoDettaglioModule),
      },

      {
        path: 'login',
        loadChildren: () =>
          import('./auth/login/login.module').then((m) => m.LoginModule),
      },

      {
        path: 'azienda',
        loadChildren: () =>
          import('./azienda/azienda.module').then((m) => m.AziendaModule),
      },

      {
        path: 'contatti',
        loadChildren: () =>
          import('./contatti/contatti.module').then((m) => m.ContattiModule),
      },

      {
        path: 'privacy',
        loadChildren: () =>
          import('./privacy/privacy.module').then((m) => m.PrivacyModule),
      },

      {
        path: 'recesso',
        loadChildren: () =>
          import('./recesso/recesso.module').then((m) => m.RecessoModule),
      },

      {
        path: 'informativa',
        loadChildren: () =>
          import('./informativa/informativa.module').then((m) => m.InformativaModule),
      },

      {
        path: 'conferma-ordine',
        loadChildren: () =>
          import('./conferma-ordine/conferma-ordine.module').then((m) => m.ConfermaOrdineModule),
      },

      {
        path: 'ordine-eseguito',
        loadChildren: () =>
          import('./ordine-eseguito/ordine-eseguito.module').then((m) => m.OrdineEseguitoModule),
      },

      {
        path: 'storico-ordini',
        loadChildren: () =>
          import('./profile/miei-ordini/miei-ordini.module').then((m) => m.MieiOrdiniModule),
      },

      {
        path: 'ordine-dettaglio/:idOrdine',
        loadChildren: () =>
          import('./profile/dettaglio-ordine/dettaglio-ordine.module').then((m) => m.DettaglioOrdineModule),
      },
      
      {
        path: 'documenti',
        loadChildren: () =>
          import('./profile/documenti/documenti.module').then((m) => m.DocumentiModule),
      },

      {
        path: 'cambioPassword',
        loadChildren: () =>
          import('./profile/cambio-password/cambio-password.module').then((m) => m.CambioPasswordModule),
      },

      {
        path: 'spedizioni',
        loadChildren: () =>
          import('./profile/spedizioni/spedizioni.module').then((m) => m.SpedizioniModule),
      },

      {
        path: 'import-ordine',
        loadChildren: () =>
          import('./profile/import-ordine/import-ordine.module').then((m) => m.ImportOrdineModule),
      },

      {
        path: 'edit-profilo',
        loadChildren: () =>
          import('./profile/edit-profilo/edit-profilo.module').then((m) => m.EditProfiloModule),
      },
      
      {
        path: 'canvass',
        loadChildren: () =>
          import('./canvass/canvass.module').then((m) => m.CanvassModule),
      },

      {
        path: 'canvass-dettaglio/:idCanvass',
        loadChildren: () =>
          import('./canvass-dettaglio/canvass-dettaglio.module').then((m) => m.CanvassDettaglioModule),
      },
      {
        path: 'canvass-dettaglio2/:idCanvass',
        loadChildren: () =>
          import('./canvass-dettaglio2/canvass-dettaglio.module2').then((m) => m.CanvassDettaglioModule2),
      },
      {
        path: 'canvass-dettaglio/:idCanvass/:paramSearch',
        loadChildren: () =>
          import('./canvass-dettaglio/canvass-dettaglio.module').then((m) => m.CanvassDettaglioModule),
      },
      {
        path: 'novita',
        loadChildren: () =>
          import('./novita/novita.module').then((m) => m.NovitaModule),
      },
      
      /*{
        path: 'ngbootstrap',
        loadChildren: () =>
          import('../modules/ngbootstrap/ngbootstrap.module').then(
            (m) => m.NgbootstrapModule
          ),
      },*/
      
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'error/404',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
